import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import { amendBillingTransaction } from "../../redux2/billing/billingSlice";

const AmendTransaction = ({ billing }) => {
  const [openModal, setOpenModal] = useState(false);
  const [values, setValues] = useState({
    type: "",
    remark: "",
    amount: 0,
    bank: "",
  });

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // If type changes to deposit, automatically set bank to wallet
    if (name === "type" && value === "deposit") {
      setValues({ ...values, [name]: value, bank: "wallet" });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const handleClick = () => {
    setOpenModal(true);
  };

  const validateForm = () => {
    if (!values.type) {
      toast.error("Please select a transaction type");
      return false;
    }
    if (!values.amount || parseFloat(values.amount) <= 0) {
      toast.error("Amount must be greater than 0");
      return false;
    }
    if (!values.remark.trim()) {
      toast.error("Description is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const data = {
        bank: values.bank,
        type: values.type,
        amount: +values.amount,
        remark: values.remark,
        id: billing?._id,
      };

      dispatch(amendBillingTransaction(data));
      toast.success("Transaction amended successfully");
      setOpenModal(false);
    } catch (error) {
      console.log(error);
      toast.error("Failed to amend transaction");
    }
  };

  return (
    <>
      <div
        className="text-gray-700 transition-colors duration-200 cursor-pointer hover:text-blue-600"
        onClick={handleClick}
      >
        Amend Transaction
      </div>

      <Modal
        show={openModal}
        onHide={() => setOpenModal(false)}
        size="lg"
        centered
        backdrop="static"
      >
        <div className="bg-white rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">
              Amend Transaction
            </h2>
            <button
              type="button"
              className="text-gray-400 transition-colors duration-200 hover:text-gray-600"
              onClick={() => setOpenModal(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Type Field */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Type <span className="text-red-500">*</span>
                </label>
                <select
                  name="type"
                  value={values?.type}
                  onChange={handleChange}
                  required
                  className="px-3 py-2 w-full rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select type</option>
                  <option value="deposit">Add Amount</option>
                  <option value="deduct">Deduct Amount</option>
                </select>
              </div>

              {/* Amount Field */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Amount <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="amount"
                  value={values?.amount}
                  onChange={handleChange}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  required
                  className="px-3 py-2 w-full rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* bank field */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Bank <span className="text-red-500">*</span>
                </label>

                <select
                  name="bank"
                  value={values?.bank}
                  onChange={handleChange}
                  required
                  disabled={values.type === "deposit"}
                  className="px-3 py-2 w-full rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value="">Select bank</option>
                  {values.type === "deposit" ? (
                    <option value="wallet">Wallet</option>
                  ) : (
                    <>
                      <option value="wallet">Wallet</option>
                      <option value="credit">Credit</option>
                    </>
                  )}
                </select>
              </div>

              {/* Description Field */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Remark <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="remark"
                  value={values?.remark}
                  onChange={handleChange}
                  placeholder="Enter remark for this amendment"
                  required
                  className="px-3 py-2 w-full rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows="3"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setOpenModal(false)}
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-md transition-colors duration-200 hover:bg-gray-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 text-white rounded-md transition-colors duration-200 bg-main-900 hover:bg-main-700"
                >
                  Submit Amendment
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AmendTransaction;
